// extracted by mini-css-extract-plugin
export var backClouds = "HomepageHero-module--backClouds--a0d39";
export var container = "HomepageHero-module--container--5a35d";
export var frontClouds = "HomepageHero-module--frontClouds--e65d2";
export var table = "HomepageHero-module--table--72475";
export var tableContainer = "HomepageHero-module--tableContainer--7c4c6";
export var tableIntroWrapper = "HomepageHero-module--tableIntroWrapper--3ccda";
export var tableTransformWrapper = "HomepageHero-module--tableTransformWrapper--5faac";
export var textContainer = "HomepageHero-module--textContainer--f2290";
export var title = "HomepageHero-module--title--424a1";
export var topCloud = "HomepageHero-module--topCloud--ef58b";
export var topContainer = "HomepageHero-module--topContainer--b2adb";